<template>
  <Layout class="m-app--layout">
    <LayoutHeader class="m-app-layout-header" :style="headerStyle">
      <Header @changeLayout="onChangeLayout" />
    </LayoutHeader>
    <LayoutContent class="m-app-layout-content" :style="contentStyle">
      <router-view />
    </LayoutContent>
    <LayoutFooter class="m-app-layout-footer">
      <Footer />
    </LayoutFooter>
  </Layout>
</template>

<script lang="ts">
import { defineComponent, onMounted, onBeforeUnmount, ref, computed } from 'vue'
import Layout from 'ant-design-vue/lib/layout'
import Header from './mobile/header/index.vue'
import Footer from './mobile/footer/index.vue'
import { useStoreHooks } from '@/store/hook'

export default defineComponent({
  components: {
    Layout,
    LayoutHeader: Layout.Header,
    LayoutFooter: Layout.Footer,
    LayoutContent: Layout.Content,
    Header,
    Footer
  },
  setup () {
    const { state } = useStoreHooks()
    const headerStyle = ref({})
    const contentStyle = ref({})
    const scrollAction: { y: string | number } = { y: 'undefined' }
    const fixed = ref(false)
    const enableScroll = computed(() => state.global.event.enableScroll)

    const changeLayout = (isFixed: boolean) => {
      if (isFixed) {
        headerStyle.value = { position: 'fixed', top: '0', zIndex: 999, width: '100%', height: '4.4rem' }
        contentStyle.value = { marginTop: '4.4rem' }
      } else {
        headerStyle.value = {}
        contentStyle.value = {}
      }
    }

    const onChangeLayout = (isFixed: boolean) => {
      fixed.value = isFixed
      changeLayout(isFixed)
    }

    const handleScroll = () => {
      if (!enableScroll.value || fixed.value) return
      if (typeof scrollAction.y === 'undefined') {
        scrollAction.y = window.pageYOffset
      }
      const diffY = Number(scrollAction.y) - window.pageYOffset
      if (diffY < 0) {
        // Scroll down
        changeLayout(false)
      } else if (diffY > 0) {
        // Scroll up
        changeLayout(true)
      }
      scrollAction.y = window.pageYOffset
    }
    onMounted(() => {
      document.addEventListener('scroll', handleScroll, false)
    })
    onBeforeUnmount(() => {
      document.removeEventListener('scroll', handleScroll)
    })

    return {
      headerStyle,
      contentStyle,
      onChangeLayout
    }
  }
})
</script>

<style lang="less" scoped>
.m-app-layout {
  /* fix firefox can't set height smaller than content on flex item */
  min-height: 100vh;

  .m-app-layout-header {
    color: rgba(0, 0, 0, 0.85);
    background: #001529;
    border-bottom: 1px solid #EAEAEA;
  }
  .m-app-layout-content {
    /* fix firefox can't set height smaller than content on flex item */
    min-height: 0;
    background: #fff;
    width: 100%;
  }
  .m-app-layout-footer {
    padding: 24px 50px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    background: #f0f2f5;
  }
}
</style>
